import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import "./search.css";
import SearchIcon from "../icons/searchIcon";

const messages = defineMessages({
    searchPlaceholder: {
        id: "search.search-placeholder",
        defaultMessage: "Search",
        description: "Search placeholder",
    },
    searchTooltip: {
        id: "search.search-tooltip",
        defaultMessage: "Search",
        description: "Search tooltip",
    },
});

/*
    Search control with css style
    props:
        - id: string, id for the input box
        - disabled: bool
        - onSearch: (value) => void
            callback with current value of the search input when enter
            key is pressed or the search icon is clicked. 
*/

const Search = (props) => {
    const [value, setValue] = useState("");
    const intl = useIntl();

    var className = "search";
    if (props.filter) {
        className = "filter-search";
    }

    return (
        <div className={className + "-wrapper"}>
            <div className={className}>
                <input
                    id={props.id}
                    className={className}
                    disabled={props.disabled}
                    placeholder={props.placeholder ? props.placeholder : intl.formatMessage(messages.searchPlaceholder)}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === "Enter") {
                            props.onSearch(value);
                        }
                    }}
                />
                <a
                    className="search-button"
                    onClick={(e) => {
                        props.onSearch(value);
                        e.stopPropagation();
                    }}>
                    <SearchIcon title={intl.formatMessage(messages.searchTooltip)} />
                </a>
            </div>
        </div>
    );
};

export default Search;
